<template>
    <span>
        <span @click="start">
            <slot :processing="processing" />
        </span>

        <Modal v-if="confirming" size="md" @close="closeModal">
            <template #header>
                <div class="text-gray-600">{{ title }}</div>
            </template>

            <template #body>
                <div class="mt-6 mb-10 w-full px-6">
                    <p class="pb-5 text-sm text-gray-500">
                        {{ content }}
                    </p>

                    <OtpInput
                            input-classes="mt-2 rounded-md text-center border border-gray-300 mx-1 sm:mx-2 focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 focus:outline-hidden transition duration-200 ease-in-out"
                            separator=""
                            :num-inputs="6"
                            :should-auto-focus="true"
                            :is-input-num="true"
                            :error="error"
                             @on-complete="onComplete"
                        />
                </div>
            </template>

            <template #footer>
                <div class="flex justify-end border-t border-gray-200 p-6">
                    <AtomicButton color="white" size="md" @click="closeModal">
                        Cancel
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </span>
</template>

<script lang="ts" setup>
import axios from 'axios';
import { route } from 'ziggy-js';
import OtpInput from '@/Pages/Auth/components/OtpInput.vue';

const props = defineProps({
    title: {
        type: String,
        default: 'Verify your identity',
    },
    content: {
        type: String,
        default: 'We sent a 6-digit code to your email address. Please enter it below to continue.',
    },

});

const emit = defineEmits(['confirmed']);

const confirming = ref(false);
const processing = ref(false);
const error = ref('');

const start = () => {
    if (processing.value || confirming.value) {
        return;
    }
    processing.value = true;
    error.value = '';

    axios
        .post(route('user.otp.store'))
        .then(() => {
            processing.value = false;
            confirming.value = true;
        })
        .catch((err) => {
            processing.value = false;
            create({
                title: 'Error',
                text: err?.response?.data?.message ?? 'Failed to send verification code. Please try again.',
                type: 'error',
            });
        });
};

const onComplete = (code: string) => {
    processing.value = true;
    error.value = '';

    axios
        .put(route('user.otp.update'), { code })
        .then(() => {
            processing.value = false;
            closeModal();
            nextTick(() => emit('confirmed'));
        })
        .catch((err) => {
            processing.value = false;
            error.value =
                err?.response?.data?.errors?.code?.[0] ??
                'Invalid code. Please try again.';
        });
};

const closeModal = () => {
    confirming.value = false;
    error.value = '';
};
</script>
